import React from 'react';

function Edit(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M3.6585 15.1785L15.7605 3.07659C17.1857 1.64532 19.5014 1.64034 20.9336 3.06649L21.1013 3.24594C22.3673 4.69649 22.2939 6.90038 20.9044 8.25787L8.82587 20.3364C8.82594 20.3364 8.8258 20.3365 8.82587 20.3364C8.82553 20.3368 8.82498 20.3373 8.82465 20.3377L8.8211 20.3412C8.74191 20.4204 8.64291 20.4768 8.53443 20.5047L2.78027 21.9805C2.32002 22.0985 1.90158 21.6802 2.01957 21.2199L3.49457 15.4657C3.52238 15.3572 3.57929 15.2578 3.6585 15.1785ZM4.43343 16.8352L3.49199 20.5061L7.16684 19.5639L4.43343 16.8352ZM8.38272 19.0114L4.98426 15.6189L15.8379 4.76684L19.2328 8.16178L8.38272 19.0114ZM20.1914 4.10442C20.9635 5.02227 20.936 6.38577 20.1154 7.27658L16.7233 3.88454C17.6229 3.05756 18.9983 3.0387 19.9187 3.82922L20.0714 3.97204L20.1914 4.10442Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Edit;
